import { FC, useEffect, useRef } from "react";
import { useField } from "formik";
import { FieldGroup, IFormProps } from ".";
import { FiasRegionSelectControlViewModel } from "../Models";
import { GarField, GarAddressType } from "src/Modules/Gar";
import { useToggle } from "@redoc/ui-kit";

interface IFiasRegionSelectControlProps extends IFormProps {
	model: FiasRegionSelectControlViewModel;
};

const FiasRegionSelectControl: FC<IFiasRegionSelectControlProps> = ( props ) => {

	const { model, setFieldValue, readOnly} = props;
	const [ inputProps,, helperProps ] = useField( model.FullPath );
	const [ , update ] = useToggle( false );
	const initialValidationDoneRef = useRef(false);

	useEffect( () => {
		model.isNeedUpdate = ( data ) => update();
	}, [] );

	useEffect( () => {
		if ( !isEqualValue(model.Value, inputProps.value) ) {
			helperProps.setValue( model.Value, true );
		}
	}, [ model.Value, inputProps.value ] );

	useEffect( () => {
		if ( initialValidationDoneRef.current ) return;
		if ( !inputProps.value || !model.data ) return;

		model.updateValue( inputProps.value, false );
		model.data.onUpdateByAddress( onTransfer(true, inputProps.value) );
		initialValidationDoneRef.current = true;

		setTimeout( () => {
			model.Validate();
			update();
		}, 0 );
	// eslint-disable-next-line
	}, [ inputProps.value, model.data ] );

	const onChangeAddress = ( address: GarAddressType | null ) => {
		console.log( "DF - onChangeAddress", address );
		if ( !address ) {
			setFieldValue(model.FullPath, null );
		}
		else {
			setFieldValue(model.FullPath, onTransfer(false, address ) );
		}
	};

	const onTransfer = ( toGar: boolean, obj: any ) => {
		if ( toGar ) {
			const _data: any = {};
			for ( const key in obj ) {
				if ( Object.prototype.hasOwnProperty.call( obj, key ) ) {
					const value = obj[key];
					_data[ toCase(key, "lower") ] = value;
				}
			}
			return ( _data as GarAddressType );
		}
		else {
			const _data: any = {};
			for ( const key in obj ) {
				if ( Object.prototype.hasOwnProperty.call( obj, key ) ) {
					const value = obj[key];
					_data[ toCase(key, "upper") ] = value;
				}
			}
			return _data;
		}
	};

	return (
		<FieldGroup
			hidden={ !model.ControlVisibility }
			name={model.FullPath} 
			title={model.Caption} 
			width={model.Width ?? 12}
			readOnly={ !model.ControlEnabling || readOnly }
			isInvalid={model.notValidClass} 
			errorMsg={model.errorMessage}
			isRequired={model.IsMandatory}
			tooltip={model.Tooltip}
		>
			{
				model.data &&
				<GarField
					name={model.FullPath}
					title={model.Caption}
					disabled={readOnly || !model.ControlEnabling}
					placeholder="Введите адрес"
					initTextValue={ model.valueToString() }
					value={onTransfer(true, inputProps.value)}
					onChangeAddress={onChangeAddress}
					model={model.data}
				/>
			}
		</FieldGroup>
	);
};

const toCase = ( str : string, type: "lower" | "upper" ): string => str.replace(/(?:^\w)/g, match => {
	if (+match === 0) return "";
	return type === "lower" ? match.toLowerCase() : match.toUpperCase();
});

const isEqualValue = ( left: unknown, right: unknown ): boolean => JSON.stringify(left ?? null) === JSON.stringify(right ?? null);

export default FiasRegionSelectControl;
